import React from "react";
import styled from "styled-components";

const StyledSwitch = styled.div`
  width: 16px;
  height: 16px;
  padding: 1px;
  background: white;
  box-shadow: 0px 2px 12px rgba(27, 27, 27, 0.04);
  border-radius: 41px;
`;

const StyledLabel = styled.span`
  color: #1b1b1b;
  font-size: 16px;
  font-family: Readex Pro;
  font-weight: 400;
  line-height: 20.48px;
  word-wrap: break-word;
`;

const StyledSwitchshape = styled.div`
  width: 36px;
  height: 20px;
  padding: 2px;
  background: #a4a4a4;
  border-radius: 58px;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  display: inline-flex;
`;

const StyledSwitchcontainer = styled.div`
  padding: 2px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  display: inline-flex;
`;

const StyledIcons = styled.div`
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  display: flex;
`;

const StyledControls = styled.div`
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  display: flex;
`;

const StyledFrame1010107212 = styled.div`
  width: 450px;
  height: 20px;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  display: flex;
`;

const StyledContainer01 = styled.div`
  align-self: stretch;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  display: inline-flex;
`;

const StyledContainer = styled.div`
  align-self: stretch;
  padding-left: 32px;
  padding-right: 32px;
  padding-top: 24px;
  padding-bottom: 24px;
  outline: 1px #e9e9e9 solid;
  outline-offset: -1px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 24px;
  display: flex;
`;

interface MissionDeployOptionProps {
  onDeployToggle?: (enabled: boolean) => void;
  isDeployEnabled?: boolean;
}

export const MissionDeployOption: React.FC<MissionDeployOptionProps> = ({
  onDeployToggle,
  isDeployEnabled = false,
}) => {
  const handleToggle = () => {
    onDeployToggle?.(!isDeployEnabled);
  };

  return (
    <StyledContainer>
      <StyledContainer01>
        <StyledControls>
          <StyledIcons>
            <StyledSwitchcontainer>
              <StyledSwitchshape
                onClick={handleToggle}
                style={{
                  background: isDeployEnabled ? "#3F7F7D" : "#A4A4A4",
                  justifyContent: isDeployEnabled ? "flex-end" : "flex-start",
                }}
              >
                <StyledSwitch />
              </StyledSwitchshape>
            </StyledSwitchcontainer>
          </StyledIcons>
        </StyledControls>
        <StyledFrame1010107212>
          <StyledLabel>Deploy the new mission?</StyledLabel>
        </StyledFrame1010107212>
      </StyledContainer01>
    </StyledContainer>
  );
};
